import { render, staticRenderFns } from "./TaskListFilterBadge.vue?vue&type=template&id=5d196354&"
import script from "./TaskListFilterBadge.vue?vue&type=script&lang=js&"
export * from "./TaskListFilterBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports